export var ApiUrls;
(function (ApiUrls) {
    ApiUrls["Auth"] = "api/Auth/";
    ApiUrls["Basket"] = "api/Basket/";
    ApiUrls["Error"] = "api/Error/";
    ApiUrls["File"] = "api/File/";
    ApiUrls["Forms"] = "wlm/Form/";
    ApiUrls["WorkloadReports"] = "wlm/Report/";
    ApiUrls["Staff"] = "wlm/Staff/";
    ApiUrls["Standard"] = "api/Standards/";
    ApiUrls["Team"] = "wlm/Team/";
    ApiUrls["Workflow"] = "wlm/Workflow/";
    ApiUrls["WlmAuth"] = "wlm/Auth/";
    ApiUrls["Eportfolio"] = "api/Eportfolio/";
})(ApiUrls || (ApiUrls = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udHJvbGxlci5hcGktZW5kcG9pbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb250cm9sbGVyLmFwaS1lbmRwb2ludC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxPQWFYO0FBYkQsV0FBWSxPQUFPO0lBQ2YsNkJBQWtCLENBQUE7SUFDbEIsaUNBQXNCLENBQUE7SUFDdEIsK0JBQW9CLENBQUE7SUFDcEIsNkJBQWtCLENBQUE7SUFDbEIsOEJBQW1CLENBQUE7SUFDbkIsMENBQStCLENBQUE7SUFDL0IsK0JBQW9CLENBQUE7SUFDcEIsc0NBQTJCLENBQUE7SUFDM0IsNkJBQWtCLENBQUE7SUFDbEIscUNBQTBCLENBQUE7SUFDMUIsZ0NBQXFCLENBQUE7SUFDckIseUNBQThCLENBQUE7QUFDbEMsQ0FBQyxFQWJXLE9BQU8sS0FBUCxPQUFPLFFBYWxCIn0=